// import Axios from 'axios'

import { logWithBadge } from './logging'

export function sendLogs(url: string, logs: any) {
  if (url) {
    // Axios.post(url, { logs: logs }).catch((_) => {})
    logWithBadge('Pusher', logs)
  }
}
